// Datasets home route (/admin/datasets): text, jurisdiction, language and build-state filters in the URL; the screen is DatasetsHome.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { VersionBuild } from "@/api/__generated__";
import { optionalList, optionalString } from "@/app/search";
import { DatasetsHome } from "@/features/datasets/DatasetsHome";

const BUILD_STATES = [
  "not_built",
  "queued",
  "building",
  "interrupted",
  "failed",
  "ready",
  "deleting",
] as const satisfies readonly VersionBuild["state"][];

const searchSchema = z.object({
  q: optionalString(),
  jurisdiction: optionalList(z.string()),
  language: optionalList(z.string()),
  build: optionalList(z.enum(BUILD_STATES)),
});

export const Route = createFileRoute("/_app/admin/datasets/")({
  validateSearch: searchSchema,
  component: DatasetsHome,
});
